import { IonText } from '@ionic/react';
import { albumsOutline, arrowRedoOutline, cardOutline, printOutline, walletOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { Modal } from 'react-responsive-modal';

import TimerFlip from '../../../components/timer/TimerFlip';
import HR from '../../../layouts/HR';
import DetailItem from '../../account/orders/order-view/DetailItem';

import './CardStatus.css';
import 'react-responsive-modal/styles.css';

interface Props {
    show: boolean,
    issueDate: string,
    status?: string,
    tracking?: string,
    post_barcode?: string,
    clickHide: any
}

const CardStatus: React.FC<Props> = (props) => {
    const [statusList, setStatusList] = useState({
        PAID: { passed: false, active: false },
        RETURNED: { passed: false, active: false },
        QUEUED: { passed: false, active: false },
        PRINTING: { passed: false, active: false },
        ISSUED: { passed: false, active: false }
    });

    useEffect(() => {
        const statusData = { ...statusList as any }

        for (let i = 0; i < Object.entries(statusData).length; i++) {
            const key = Object.keys(statusData)[i];

            if (props.status === undefined || props.status == '' || props.status == 'NONE') {
                break;
            }

            if (key == props.status!) {
                statusData[key].passed = true;
                statusData[key].active = true;
                break;
            } else {
                statusData[key].passed = true;
            }
        }

        setStatusList(statusData);
    }, [])

    const hasTimer = props.issueDate != '';

    return <Modal open={props.show} onClose={props.clickHide} center showCloseIcon={false} classNames={{modalContainer: "card-status-modal"}}>
        <div className="ion-margin-bottom">
            <IonText><strong>وضعیت کارت</strong></IonText>
        </div>

        <DetailItem icon={walletOutline} title="پرداخت شده" passed={statusList.PAID.passed} active={statusList.PAID.active} />

        <DetailItem icon={arrowRedoOutline} title="برگشت خورده" passed={statusList.RETURNED.passed} active={statusList.RETURNED.active} />

        <DetailItem icon={albumsOutline} title="در صف صدور" passed={statusList.QUEUED.passed} active={statusList.QUEUED.active} />

        <DetailItem icon={printOutline} title="در حال چاپ" passed={statusList.PRINTING.passed} active={statusList.PRINTING.active} />

        {props.status != 'ISSUED' ?
            <DetailItem icon={cardOutline} title="صادر شده" passed={statusList.ISSUED.passed} active={statusList.ISSUED.active} />
            :
            <DetailItem icon={cardOutline} title={`صادر شده <a target="_blank" href="${props.tracking}">(رهگیری)</a>`} subtitle={`بارکد مرسوله: ${props.post_barcode}`} passed={statusList.ISSUED.passed} active={statusList.ISSUED.active} />
        }

        {hasTimer ?
            <>
                <HR />

                <div className="ion-margin-top">
                    <IonText>زمان باقیمانده تا دریافت کارت حامی طبیعت</IonText>
                </div>

                <div className="ion-margin-top">
                    <TimerFlip endDate={props.issueDate} />
                </div>
            </>
            : null}
    </Modal>
}

export default CardStatus